import Cardtable from "./Cardtable";

export default Cardtable;